/**
 * Filters an array to contain only unique elements based on a specified key.
 *
 * @param arr - The input array to filter.
 * @param key - The key to use for determining uniqueness.
 * @returns A new array containing only the unique elements from the input array.
 */
function uniqueBy<T, K extends keyof T>(arr: T[], key: K): T[] {
  const seen = new Set<T[K]>();
  return arr.filter((item) => {
    const value = item[key];
    if (seen.has(value)) {
      return false;
    }
    seen.add(value);
    return true;
  });
}

export { uniqueBy };
